import { render, staticRenderFns } from "./ProcessInstanceContext.vue?vue&type=template&id=55ef439a&scoped=true"
import script from "./ProcessInstanceContext.vue?vue&type=script&lang=js"
export * from "./ProcessInstanceContext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ef439a",
  null
  
)

export default component.exports